var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3 7.3a4.06 4.06 0 0 1 8.11 0v2.9l1.45 2.35H2.85L4.3 10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.3a1.7 1.5 0 0 0 3.2 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.1faa321d63f68e4d8d336c79e109c7b8.svg";
export { ForwardRef as ReactComponent };